import React from "react";
import Div from "../../../../widget/common/ui/Div";
import {
  AutomatedReplyMessageField,
  AutomatedReplyToggleField,
} from "./AutomatedReplyTextfields";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import { AutomatedReplyContextImport } from "../../../../provider/work_profile/automated_reply/AutomatedReplyContextProvider";
import Center from "../../../../widget/common/ui/Center";
import { TextBlock } from "../../../../widget/common/ui/Text";
import Loader from "../../../../widget/common/ui/Loader";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import DisableContent from "../../../../widget/common/ui/DisableContent";

const AutomatedReplyAlert = () => {
  const {
    handleSubmit,
    handleClear,
    loadedStatus,
    statusField,
    allowEdit,
    handleEdit,
  } = AutomatedReplyContextImport();

  return (
    <>
      {!loadedStatus ? (
        <Center className="py-4">{Loader.normal()}</Center>
      ) : (
        <form autoComplete="off">
          <Div className="d-flex align-items-center justify-content-between px-2">
            <TextBlock fontName="bold" fontSize="16_17" textColor="primary">
              {AppTranslation.text("activate")}
            </TextBlock>
            <AutomatedReplyToggleField />
          </Div>

          {statusField ? (
            <>
              <DisableContent status={!allowEdit}>
                <Div className="pb-2">
                  <AutomatedReplyMessageField />
                </Div>

                <Center>
                  <ButtonSingle
                    handleClick={() => handleClear()}
                    width={300}
                    bgColor="white"
                    fontName="book"
                    fontSize="13_14"
                    textColor="theme-label"
                    className="mb-3"
                  >
                    {AppTranslation.text("clear")}
                  </ButtonSingle>
                </Center>
              </DisableContent>
              <Center>
                <ButtonSingle
                  handleClick={() =>
                    allowEdit ? handleSubmit() : handleEdit()
                  }
                  width={300}
                >
                  {AppTranslation.text(allowEdit ? "submit" : "change")}
                </ButtonSingle>
              </Center>
            </>
          ) : (
            <SpacingHeight value={50} />
          )}
        </form>
      )}
    </>
  );
};

export default AutomatedReplyAlert;
